export const toCleanString = (elements: Array<string | number | undefined | null>, separator?: string) =>
  (elements.filter((a) => !!a) as string[]).join(separator || ' ');
